import { createSlice } from "@reduxjs/toolkit";
import { BaseMapsName } from "../../constants/baseMaps";
const initialState = {
    legend: null,
    measurerActive: false,
    baseMapsOpen: false,
    baseMapsName: BaseMapsName["2GIS"],
};
const slice = createSlice({
    name: "map",
    initialState,
    reducers: {
        setLegend: (state, action) => {
            state.legend = action.payload;
        },
        setMeasurerActive: (state, action) => {
            state.measurerActive = action.payload;
        },
        setBaseMapsOpen: (state, action) => {
            state.baseMapsOpen = action.payload;
        },
        setBaseMapsName: (state, action) => {
            state.baseMapsName = action.payload;
        },
        setCurrentFeature: (state, action) => {
            state.currentFeature = action.payload;
        },
        setOverlayFeature: (state, action) => {
            state.overlayFeature = action.payload;
        },
        resetMap: () => initialState,
    },
});
export const { setLegend, setMeasurerActive, setBaseMapsOpen, setBaseMapsName, setCurrentFeature, setOverlayFeature, resetMap, } = slice.actions;
export default slice.reducer;
